<template>
  <x-form
    @submit="submit"
    :submit-text="submitLabel"
    :submit-help="$t('Attiva almeno una tipologia di permessi o di notifiche')"
    :prevent-submit="disabled || (!user.emailSubscriptions.length && !user.grants.length)"
    v-bind="ouiaProps"
  >
    <slot />
    <form-group
      v-if="!user.is_owner"
      :name="$t('Rendi Amministratore')"
      :field-help="$t('Concedi privilegi di amministrazione di tutti i servizi e visione dei dati aziendali')"
    >
      <pf-switch
        :checked="user.grants.includes('admin')"
        name="grants[]"
        value="admin"
        off-value="0"
        :label="$t('Ammininistratore')"
        @update:checked="user.grants = $event ? ['admin'] : []"
        :ouia-id="`${ouiaProps['data-ouia-component-id']}-grants-admin`"
      />
    </form-group>

    <pf-flex>
      <pf-flex-item v-if="!user.is_owner">
        <form-group :name="$t('Oppure concedi questi privilegi')">
          <pf-switch-list
            style="max-width: var(--pf-v6-c-switchlist--ColumnWidth)"
            :disabled="user.grants.includes('admin')"
            :model-value="user.grants"
            @update:model-value="user.grants = $event"
            name="grants[]"
            :items="$as<typeof user.grants>(['billing', 'sales', 'developer'])"
            :ouia-id="`${ouiaProps['data-ouia-component-id']}-grants`"
          />
        </form-group>
      </pf-flex-item>
      <pf-flex-item>
        <form-group :name="$t('Notifiche Email')">
          <pf-switch-list
            style="max-width: var(--pf-v6-c-switchlist--ColumnWidth)"
            :model-value="user.emailSubscriptions"
            @update:model-value="user.emailSubscriptions = $event"
            name="emailSubscriptions[]"
            :items="$as<typeof user.emailSubscriptions>(['billing', 'marketing', 'technical'])"
            :ouia-id="`${ouiaProps['data-ouia-component-id']}-emailsubscription`"
          />
        </form-group>
      </pf-flex-item>
    </pf-flex>
  </x-form>
</template>

<style scoped lang="scss">
:deep(.pf-v6-c-switchlist) {
  display: flex;
  flex-direction: column;

  .pf-v6-c-switch {
    margin-bottom: 4px;
  }
}
</style>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import PfSwitchList from '@common/PfSwitchList.vue';
import { cloneDeep } from 'lodash-es';
import { ref } from 'vue';

export type FormUserData = {
  is_owner?: boolean;
  emailSubscriptions: ('billing' | 'marketing' | 'technical')[];
  grants: ('billing' | 'sales' | 'developer' | 'admin')[];
};

const props = defineProps<
  OUIAProps & {
    modelValue: FormUserData;
    disabled: boolean;
    submitLabel: string;
  }
>();
const ouiaProps = useOUIAProps(props);

const emit = defineEmits<{
  (e: 'update:modelValue', value: FormUserData): void;
}>();

const user = ref(cloneDeep(props.modelValue));

function submit() {
  emit('update:modelValue', user.value);
}
</script>
